import { useEffect, useState } from 'react';

/**
 * MATRIX: ON / OFF toggle — fixed to top-right of the page.
 * Default: ON (matrix rain visible, black bg).
 * OFF: navy gradient bg, canvas hidden. Adds "matrix-off" class to <body>.
 * Persists to localStorage under "nb-matrix-off".
 */
export default function MatrixToggle() {
  const [off, setOff] = useState(() => {
    try {
      return localStorage.getItem('nb-matrix-off') === '1';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    if (off) {
      document.body.classList.add('matrix-off');
      document.body.classList.remove('matrix-skin');
      try { localStorage.setItem('nb-matrix-off', '1'); } catch { /* ignore */ }
    } else {
      document.body.classList.remove('matrix-off');
      document.body.classList.add('matrix-skin');
      try { localStorage.setItem('nb-matrix-off', '0'); } catch { /* ignore */ }
    }
  }, [off]);

  return (
    <button
      data-testid="matrix-toggle-btn"
      onClick={() => setOff((v) => !v)}
      style={{
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 9999,
        background: 'rgba(0,0,0,0.8)',
        border: '1px solid #00FF41',
        borderRadius: 8,
        padding: '10px 16px',
        fontFamily: 'Orbitron, sans-serif',
        fontSize: 10,
        fontWeight: 700,
        color: '#00FF41',
        cursor: 'pointer',
        letterSpacing: 1,
        boxShadow: '0 0 10px rgba(0,255,65,0.3)',
        transition: 'all 0.3s',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 0 20px rgba(0,255,65,0.6)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = '0 0 10px rgba(0,255,65,0.3)';
      }}
    >
      {off ? 'MATRIX: OFF' : 'MATRIX: ON'}
    </button>
  );
}

export function useMatrixOff() {
  const [off, setOff] = useState(() => {
    try {
      return localStorage.getItem('nb-matrix-off') === '1';
    } catch {
      return false;
    }
  });
  useEffect(() => {
    const onStorage = () => {
      try {
        setOff(localStorage.getItem('nb-matrix-off') === '1');
      } catch { /* ignore */ }
    };
    window.addEventListener('storage', onStorage);
    // Also poll body class in case toggle is on same page
    const iv = setInterval(() => {
      setOff(document.body.classList.contains('matrix-off'));
    }, 500);
    return () => {
      window.removeEventListener('storage', onStorage);
      clearInterval(iv);
    };
  }, []);
  return off;
}
